export const menu = [
   {
      name : "Մարտական Հերթապահություն",
      category: "duty",
      undercategory: [
         {
            name : "Հենակետեր (Դիրքեր)",
            category: "base",
            undercategory : null
         },         
         {
            name: "Գնդակոծում",
            category : "firing",
            undercategory : null
         },

         {
            name: "Պատահար",
            category : "accident",
            undercategory : null
         },

         {
            name: "Ստուգում",
            category : "check",
            undercategory : null,
         },
      ]
   },

   {
      name : "Պատահար զորամասում",
      category: "accident-unit"
    },

    {
      name: "Ստուգում զորամասում",
      category: "check-unit"
    },
   {
      name: "Կարգավորումներ",
      category: "addings",
      undercategory : [
         {
            name: "Կորպուս",
            category: "corpus",
            undercategory : null
         },
         {
            name: "Զորամաս",
            category: "mil_unit",
            undercategory : null
         },
         {
            name: "Գումարտակ",
            category: "battalion",
            undercategory : null
         },
         {
            name: "Վաշտ",
            category: "company",
            undercategory : null
         },
         {
            name: "Դասակ",
            category: "platoon",
            undercategory : null
         },
         {
            name: "Զենքի տեսակներ",
            category: "weapon",
            undercategory : null
         },
         {
            name: "Անձնակազմ",
            category: "people",
            undercategory : null
         }
      ]
   }




   ]